import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import BlogFilter from "@/components/Shared/BlogFilter";
import vector from "@/assets/blog/blog-vector.png";
import "@sourceflow-uk/job-search/dist/bundle.css";
import useLocale from "@/hooks/useLocale";

export default function BlogBanner({ blogs }) {
  const locale = useLocale();

  return (
    <div>
      <img src={vector ?? ""} alt="vector" className="absolute top-0 left-0" />
      <div className="container pt-40 sm:pt-20 relative z-50 job_search">
        <h1 className="text-[40px]/[50px] md:text-6xl lg:text-[100px] max-w-[957px]">
          <CustomSourceFlowText
            title="We’re up-to-date with all things tech."
            path="dynamic1.mainblog.heading1"
            locale={locale}
          />
        </h1>
        <div className="z-50 relative pt-16 pb-5">
          <BlogFilter blogs={blogs} />
        </div>
      </div>
    </div>
  );
}
